<template>
  <div :class="{ 'has-error': validacao.$error }" class="form-group">
    <label v-if="exibeLabel">
      {{ label }} <sup>{{ labelSup }}</sup>
    </label>
    <select
      :id="id"
      :data-test-id="`select-${id}`"
      :name="id"
      :disabled="somenteLeitura"
      :value="valor"
      :class="{ 'form-control': true, 'input-sm': tamanho === 'sm' }"
      @change="atualizar($event.target)"
    >
      <option v-if="opcaoSemValor" value="">
        {{ opcaoSemValor }}
      </option>
      <option
        v-for="v in valores"
        :key="v[chave]"
        :value="v[chave]"
        :selected="v[chave] === valorInterno[chave]"
      >
        {{ v[descricao] }}
      </option>
    </select>
    <div v-if="validacao.$dirty" class="help-block">
      <slot name="mensagensValidacao" />
    </div>
  </div>
</template>

<script>
import { campoMixin } from '@/mixins/CampoMixin'

export default {
  name: 'SelecionarGenerico',
  mixins: [campoMixin],
  props: {
    label: {
      type: String,
      default: '',
    },
    id: {
      type: String,
      required: true,
    },
    opcaoSemValor: {
      type: String,
      default: '',
    },
    valores: {
      type: Array,
      required: true,
    },
    chave: {
      type: String,
      default: '_id',
    },
    descricao: {
      type: String,
      default: 'descricao',
    },
    tamanho: {
      type: String,
      default: '',
    },
  },
}
</script>
